import { z } from "zod";
import { defineEndpoint } from "./endpoint.js";
const checkStatusSchema = z.enum(["up", "down"]);
/** `GET /health/live`: the process is running. */
export const liveResponseSchema = z.object({ status: z.literal("ok") });
/**
 * `GET /health/ready`: dependencies are reachable. Never carries error text or connection details.
 * Served with 200 when every check is `up`, otherwise 503.
 */
export const readyResponseSchema = z.object({
    status: z.enum(["ok", "unavailable"]),
    checks: z.object({ db: checkStatusSchema, redis: checkStatusSchema }),
});
// Endpoints -------------------------------------------------------------------------------------------------
export const healthLive = defineEndpoint({
    name: "healthLive",
    method: "GET",
    path: "/health/live",
    access: { public: true },
    summary: "Liveness probe: the process runs",
    tag: "health",
    status: 200,
    response: liveResponseSchema,
});
export const healthReady = defineEndpoint({
    name: "healthReady",
    method: "GET",
    path: "/health/ready",
    access: { public: true },
    summary: "Readiness probe: Postgres and Redis reachable (503 otherwise)",
    tag: "health",
    status: 200,
    response: readyResponseSchema,
});
/** `GET /docs` and `/docs/openapi.json`: development and staging only (404 elsewhere). */
export const docsPage = defineEndpoint({
    name: "docsPage",
    method: "GET",
    path: "/docs",
    access: { public: true },
    summary: "API reference (HTML); development and staging only",
    tag: "docs",
    status: 200,
    produces: "text/html",
});
export const docsOpenApi = defineEndpoint({
    name: "docsOpenApi",
    method: "GET",
    path: "/docs/openapi.json",
    access: { public: true },
    summary: "This OpenAPI document; development and staging only",
    tag: "docs",
    status: 200,
});
//# sourceMappingURL=health.js.map